import * as React from "react";
import { Chip, useTheme, ChipProps } from "@material-ui/core";
import { lighten } from "@material-ui/core/styles";
import { themeVariables } from "..";
import * as styles from "./styles.scss";
import { ModifyType } from "../../../../utils";

type IProps = ModifyType<
  ChipProps,
  {
    color: number | string;
    bgColor?: string;
    isBorder?: boolean;
    deleteIcon?: any;
    onDelete?: any;
  }
>;

export const MUIChip = (props: IProps) => {
  const theme = useTheme();
  const color =
    typeof props.color === "number"
      ? themeVariables.palette.marks[props.color] || "#000"
      : props.color;

  return (
    <Chip
      size={props.size}
      label={props.label}
      style={{
        color: color,
        backgroundColor: props.bgColor ? props.bgColor : lighten(color, 0.8),
        borderRadius: theme.shape.borderRadius,
        border: props.isBorder ? `1px solid ${color}` : "",
      }}
      className={styles.chip}
      deleteIcon={props.deleteIcon}
      onDelete={props.onDelete}
    />
  );
};
